import { render, staticRenderFns } from "./AkdainaEvent.vue?vue&type=template&id=4a3b929e&scoped=true"
import script from "./AkdainaEvent.vue?vue&type=script&lang=js"
export * from "./AkdainaEvent.vue?vue&type=script&lang=js"
import style0 from "./AkdainaEvent.vue?vue&type=style&index=0&id=4a3b929e&prod&lang=scss&scoped=true"
import style1 from "./AkdainaEvent.vue?vue&type=style&index=1&id=4a3b929e&prod&lang=scss&scoped=true"
import style2 from "./AkdainaEvent.vue?vue&type=style&index=2&id=4a3b929e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3b929e",
  null
  
)

export default component.exports